module.exports = __webpack_public_path__ + "img/hy.4777c015.png";